// Push в приложении после переезда на единый Firebase-проект (OXEM-549/550).
//
// В Novu одна FCM-интеграция — ключ `international-exchange-center`. Нативные
// сборки на прежнем проекте получают токены, которые доставить нечем, а веб-часть
// приходит к ним по OTA — поэтому «обновите приложение» рисует веб-часть, а
// старую сборку определяет нативный слой (`isPushAppUpdateRequired`).

import { getCapacitorPlugin } from "@studyhub/platform/lib/capacitor-plugin";
import { toast } from "@studyhub/ui/toast";
import i18n from "@/i18n";
import { nativeAuthSurface } from "@/lib/native-auth-surface";

// Android — схема `market://`, а не https-адрес магазина: бандл один на обе платформы,
// и App Store (guideline 2.3.10) режет упоминания чужого магазина в бинарнике
// (см. lib/foreign-store-references.test.ts). Системный запуск откроет магазин сам.
const STORE_URL = {
	ios: "https://apps.apple.com/app/id6806271940",
	android: "market://details?id=app.study.iec.exchange",
} as const;

/** Не чаще раза в сутки — напоминание, а не баннер на каждом запуске. */
const TOAST_SHOWN_KEY = "studyhub:push-update-toast-shown-at";
const TOAST_INTERVAL_MS = 24 * 60 * 60 * 1000;

/** Страница приложения в сторе — через системный запуск ссылок, иначе вкладкой. */
export function openAppUpdatePage(): void {
	const url = STORE_URL[nativeAuthSurface() ?? "android"];
	const launcher = getCapacitorPlugin<{ openUrl(options: { url: string }): Promise<unknown> }>(
		"AppLauncher",
	);
	if (launcher) {
		void launcher.openUrl({ url }).catch(() => window.open(url, "_blank", "noopener"));
		return;
	}
	window.open(url, "_blank", "noopener");
}

/** Тост «обновите приложение» с кнопкой в стор. */
export function showPushAppUpdateToast(): void {
	toast(i18n.t("notifications:pushUpdate.message"), {
		id: "push-app-update",
		duration: 12_000,
		action: { label: i18n.t("notifications:pushUpdate.action"), onClick: openAppUpdatePage },
	});
}

/**
 * Напоминание на старте. Только тем, кто уже разрешил уведомления: они их сейчас
 * теряют. Остальных не тревожим — разрешение мы у старой сборки не просим.
 */
export function remindPushAppUpdate(): void {
	try {
		const lastShown = Number(localStorage.getItem(TOAST_SHOWN_KEY) ?? 0);
		if (Date.now() - lastShown < TOAST_INTERVAL_MS) return;
		localStorage.setItem(TOAST_SHOWN_KEY, String(Date.now()));
	} catch {
		// localStorage недоступен — покажем без ограничения частоты, не критично.
	}
	showPushAppUpdateToast();
}
